module.exports = __webpack_public_path__ + "img/github.b0c1b0dc.svg";